import CloudOffIcon from "@mui/icons-material/CloudOff";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";

export default function NoConnection({
  message = "Please try again.",
  alignment = "center",
}) {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          height: "50%",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CloudOffIcon
          color="primary"
          sx={{ maxWidth: 100, height: "100%", width: "100%", p: 1 }}
        />
      </Box>
      <Box sx={{ textAlign: "center", pb: 1 }}>
        <Typography variant="h6" align={alignment} sx={{ mb: 2 }}>
          Error connecting to the server
        </Typography>
        <Typography color="textSecondary" align={alignment}>
          {message}
        </Typography>
      </Box>
    </>
  );
}
